import { UsersPermissions } from "@/types/Permissions.interface";
import styles from "./SampleAnyPermissions.module.css";
import { Key } from "antd/es/table/interface";
import React from "react";

interface sampleAnyPermissionsProps {
  typePermsName: Key;
  typePermsData: UsersPermissions;
  overPriv?: string[];
}

export const SampleAnyPermissions = ({
  typePermsName,
  typePermsData,
  overPriv,
}: sampleAnyPermissionsProps) => {
  const titles = {
    users: "Пользователи",
    wines: "ВиноТовары",
    addresses: "Адреса",
    fairs: "События",
    tours: "Туры",
    video_pages: "Видеообложки страниц",
  };
  const title = Object.entries(titles).map(([key, value]: [Key, string]) => {
    if (key === typePermsName) return value;
  });

  return (
    <div className={styles.iterationPermissions}>
      <span>{title}:</span>
      <div className={styles.permissionsBlock}>
        <span className={`${styles.typePermissions} ${typePermsData["add"] ? styles.active : ""}`}>
          Создавать
        </span>
        <p>/</p>
        <span className={`${styles.typePermissions} ${typePermsData["edit"] ? styles.active : ""}`}>
          Редактировать
        </span>
        <p>/</p>
        <span className={`${styles.typePermissions} ${typePermsData["delete"] ? styles.active : ""}`}>
          Удалять
        </span>
      </div>

      {overPriv && (
        <>
          <span>пользователей</span>
          <div className={styles.typeRole}>
            {overPriv.map((item, index) => (
              <React.Fragment key={`${title}-${index}`}>
                <span>{item}</span>
                {index !== overPriv.length - 1 && <p>/</p>}
              </React.Fragment>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
